import { API } from "aws-amplify";
import { APIS } from "../../utils/apiUtils";
import { AppDispatch } from "../../redux/store";
import {
    setSubscriptionStatus,
    setSubscriptionLoading,
    SubscriptionStatusPayload,
} from "../../redux/subscriptionSlice";

export const getSubscriptionStatus = async (
    accountId: string,
    dispatch: AppDispatch
): Promise<SubscriptionStatusPayload> => {
    try {
        dispatch(setSubscriptionLoading(true));
        const data: SubscriptionStatusPayload = await API.get(
            APIS.BILLING_API,
            "/subscription-status",
            {
                queryStringParameters: { accountId },
            }
        );
        dispatch(setSubscriptionStatus(data));
        return data;
    } catch (error) {
        console.error("Failed to get subscription status:", error);
        dispatch(
            setSubscriptionStatus({
                status: "not_initialized",
                subscriptionId: null,
                trialEnd: null,
                isActive: false,
            })
        );
        throw error;
    }
};

export const initializeSubscription = async (
    accountId: string,
    dispatch: AppDispatch
): Promise<SubscriptionStatusPayload> => {
    try {
        dispatch(setSubscriptionLoading(true));
        const data: SubscriptionStatusPayload = await API.get(
            APIS.BILLING_API,
            "/initialize-subscription",
            {
                queryStringParameters: { accountId },
            }
        );
        dispatch(setSubscriptionStatus(data));
        return data;
    } catch (error) {
        console.error("Failed to initialize subscription:", error);
        dispatch(setSubscriptionLoading(false));
        throw error;
    }
};

export const activateSubscription = async (
    accountId: string,
    dispatch: AppDispatch
): Promise<void> => {
    try {
        dispatch(setSubscriptionLoading(true));
        await API.get(APIS.BILLING_API, "/activate-subscription", {
            queryStringParameters: { accountId },
        });
        setTimeout(async () => {
            await getSubscriptionStatus(accountId, dispatch);
        }, 2000);
    } catch (error) {
        console.error("Failed to activate subscription:", error);
        dispatch(setSubscriptionLoading(false));
        throw error;
    }
};
